import React from 'react';
import PropTypes from 'prop-types';

import './link.scss';

export default function Link(props) {
  let target = Array.isArray(props.target) ? props.target[0] : props.target;
  return (
    <a 
      data-testid={props.testid}
      data-external-target={props.externalTarget}
      className={`aps__link ${props.classes}`}
      href={props.link}
      target={Array.isArray(props.target) ? props.target[0] : props.target}
      onClick={props.action}
    >
      <div className={`link__column`}>
        {props.children}
      </div>
      {target === '_blank' &&
        <img className="icon" src={`//aps.autodesk.com/static/1.0.0.20250424162325/images/icon-external.svg`}/>
      }
    </a>
  );
};

Link.propTypes = {
  link: PropTypes.string,
  target: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  classes: PropTypes.string,
  action: PropTypes.func,
  children: PropTypes.node,
  testid: PropTypes.string,
  externalTarget: PropTypes.string,
};

Link.defaultProps = {
  link: '',
  target: '',
  classes: '',
  action: null,
  testid: '',
  externalTarget: '',
};
